(function () {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    const triggers = document.querySelectorAll('[data-cart-trigger]');
    const closeBtn = drawer.querySelector('[data-cart-drawer-close]');
    const sectionId = drawer.closest('.shopify-section');
    const id = sectionId ? sectionId.id.replace('shopify-section-', '') : '';

    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isLeft = drawer.classList.contains('cart-drawer--left');
    const offPct = isLeft ? -100 : 100;

    function panel() { return drawer.querySelector('[data-cart-drawer-panel]'); }
    function hasGsap() { return typeof window.gsap !== 'undefined'; }

    let isOpen = false;
    let openTween, closeTween;

    function open() {
      if (isOpen) return;
      isOpen = true;
      if (typeof drawer.showModal === 'function') drawer.showModal();
      else drawer.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      const p = panel();
      if (!p) return;
      if (reduced || !hasGsap()) {
        p.style.transform = 'translateX(0)';
        return;
      }
      if (closeTween) closeTween.kill();
      window.gsap.set(p, { xPercent: offPct, x: 0 });
      openTween = window.gsap.to(p, { xPercent: 0, duration: 0.35, ease: 'power3.out' });
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      document.documentElement.style.overflow = '';
      const p = panel();
      function finish() {
        if (typeof drawer.close === 'function') drawer.close();
        else drawer.removeAttribute('open');
      }
      if (!p || reduced || !hasGsap()) { finish(); return; }
      if (openTween) openTween.kill();
      closeTween = window.gsap.to(p, {
        xPercent: offPct, duration: 0.25, ease: 'power3.in',
        onComplete: function () { finish(); window.gsap.set(p, { clearProps: 'transform' }); }
      });
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    });
    drawer.addEventListener('close', function () {
      // Fires when dialog closes for any reason (Escape, dialog.close()).
      // Keep our isOpen flag in sync so the next open() actually runs.
      isOpen = false;
      document.documentElement.style.overflow = '';
    });

    // Refresh drawer body when cart:updated fires (from M4-7 async ATC).
    document.addEventListener('cart:updated', function () {
      refresh();
      open();
    });

    // Open on the header / mobile tab-bar cart trigger.
    // section-header.js turns [data-cart-open] clicks into a 'cart:open' event.
    document.addEventListener('cart:open', function () {
      open();
    });

    function refresh() {
      if (!id) return;
      fetch('/?section_id=' + encodeURIComponent(id), { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('[data-cart-drawer]');
          if (!fresh) return;
          const oldPanel = drawer.querySelector('[data-cart-drawer-panel]');
          const newPanel = fresh.querySelector('[data-cart-drawer-panel]');
          if (oldPanel && newPanel) {
            // Drawer may be open — lock the new panel into the docked position
            // so the swap doesn't visually jump.
            if (isOpen) newPanel.style.transform = 'translateX(0)';
            oldPanel.replaceWith(newPanel);
            const newClose = drawer.querySelector('[data-cart-drawer-close]');
            if (newClose) newClose.addEventListener('click', close);
            // Panel was swapped: snap the (delegated) view router back to default.
            if (window.SherbetCart && window.SherbetCart.resetView) window.SherbetCart.resetView();
          }
        })
        .catch(function () { /* silent */ });
    }

    // Expose globally for sibling modules (drawer.refresh() etc.)
    window.SherbetCart = window.SherbetCart || {};
    window.SherbetCart.open = open;
    window.SherbetCart.close = close;
    window.SherbetCart.refresh = refresh;

    // -------- Line item editing (M6-3) --------
    // Shared across the drawer and the /cart page. Anything with a
    // [data-cart-line-key] action button or [data-cart-quantity-input]
    // will POST to /cart/change.js and re-render both the drawer and
    // the cart page (whichever is on the page).

    function changeLine(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      }); });
    }

    function findCartPageSectionId() {
      const cartSection = document.querySelector('.section-main-cart');
      if (!cartSection) return '';
      const wrap = cartSection.closest('.shopify-section');
      return wrap ? wrap.id.replace('shopify-section-', '') : '';
    }

    function refreshCartPage() {
      const cartId = findCartPageSectionId();
      if (!cartId) return Promise.resolve();
      return fetch('/cart?section_id=' + encodeURIComponent(cartId))
        .then(function (r) { return r.text(); })
        .then(function (text) {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const oldRoot = document.querySelector('.section-main-cart');
          const newRoot = doc.querySelector('.section-main-cart');
          if (oldRoot && newRoot) oldRoot.replaceWith(newRoot);
        });
    }

    function refreshAll() {
      return Promise.all([refresh(), refreshCartPage()])
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refreshed', { bubbles: true }));
        });
    }

    function setLineBusy(key, busy) {
      document.querySelectorAll('[data-cart-item-key="' + CSS.escape(key) + '"]').forEach(function (el) {
        if (busy) el.setAttribute('data-busy', 'true');
        else el.removeAttribute('data-busy');
      });
    }

    let quantityTimer;
    document.addEventListener('click', function (e) {
      // Quantity stepper
      const step = e.target.closest('[data-cart-quantity-step]');
      if (step) {
        const key = step.dataset.cartLineKey;
        const delta = parseInt(step.dataset.cartQuantityStep, 10) || 0;
        const input = document.querySelector('[data-cart-quantity-input="' + CSS.escape(key) + '"]');
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = next;
        setLineBusy(key, true);
        changeLine(key, next).then(refreshAll).catch(function () {})
          .finally(function () { setLineBusy(key, false); });
        e.preventDefault();
        return;
      }
      // Remove link
      const remove = e.target.closest('[data-cart-item-remove]');
      if (remove) {
        const key = remove.getAttribute('data-cart-item-remove');
        setLineBusy(key, true);
        changeLine(key, 0).then(refreshAll).catch(function () {})
          .finally(function () { setLineBusy(key, false); });
        e.preventDefault();
        return;
      }
    });

    document.addEventListener('change', function (e) {
      const input = e.target.closest('[data-cart-quantity-input]');
      if (!input) return;
      const key = input.getAttribute('data-cart-quantity-input');
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      clearTimeout(quantityTimer);
      quantityTimer = setTimeout(function () {
        setLineBusy(key, true);
        changeLine(key, qty).then(refreshAll).catch(function () {})
          .finally(function () { setLineBusy(key, false); });
      }, 200);
    });

    // -------- View router (M6 refactor) --------
    // The drawer body hosts multiple [data-cart-view] sections; only one
    // is shown at a time. A back stack tracks navigation so the back
    // button is generic. Default view sits at the bottom of the stack
    // and is never popped off.

    // Cart view router. The drawer panel is replaced wholesale on every cart
    // update, so all handlers are delegated on the persistent `drawer` element
    // and every DOM lookup is done live at interaction time. Caching panel
    // nodes here pointed at the detached pre-refresh panel after the first
    // add-to-cart, which is exactly what killed the shipping / discount / note
    // toggles once items were in the cart.
    var viewStack = ['default'];
    var cartDefaultTitle = null;

    function cartBody() { return drawer.querySelector('[data-cart-drawer-body]'); }

    function showView(name) {
      var body = cartBody();
      if (!body) return false;
      var views = Array.prototype.slice.call(body.querySelectorAll('[data-cart-view]'));
      if (views.length < 2) return false; // empty cart, nothing to route
      var backBtn = drawer.querySelector('[data-cart-back]');
      var titleEl = drawer.querySelector('[data-cart-view-title]');
      if (titleEl && cartDefaultTitle === null) cartDefaultTitle = titleEl.innerHTML;

      var found = false;
      views.forEach(function (v) {
        var match = v.getAttribute('data-cart-view') === name;
        v.hidden = !match;
        v.classList.toggle('is-active', match);
        if (match) found = true;
      });
      if (!found) return false;
      if (backBtn) backBtn.hidden = name === 'default';
      if (titleEl) {
        if (name === 'default') {
          if (cartDefaultTitle !== null) titleEl.innerHTML = cartDefaultTitle;
        } else {
          var view = body.querySelector('[data-cart-view="' + name + '"]');
          var label = view && view.getAttribute('data-cart-view-label');
          titleEl.textContent = label || name;
        }
      }
      body.scrollTop = 0;
      if (titleEl) {
        titleEl.setAttribute('tabindex', '-1');
        setTimeout(function () { titleEl.focus({ preventScroll: true }); }, 80);
      }
      return true;
    }

    function goView(name) {
      if (viewStack[viewStack.length - 1] === name) return;
      viewStack.push(name);
      showView(name);
    }
    function backView() {
      if (viewStack.length <= 1) return;
      viewStack.pop();
      showView(viewStack[viewStack.length - 1]);
    }
    function resetView() {
      viewStack.length = 1; viewStack[0] = 'default';
      showView('default');
    }
    // Exposed so refresh() can reset the view after swapping the panel.
    window.SherbetCart.resetView = resetView;

    // All bound ONCE on the persistent drawer (delegated), so they survive
    // every panel replacement.
    drawer.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-cart-go]');
      if (trigger) { e.preventDefault(); goView(trigger.getAttribute('data-cart-go')); return; }
      if (e.target.closest && e.target.closest('[data-cart-back]')) { e.preventDefault(); backView(); }
    });
    drawer.addEventListener('close', resetView);
  })();
